export default __webpack_public_path__ + "static/media/Wt_Price.d7fe233b.svg";